import { render, staticRenderFns } from "./hospitalCheckedReport.vue?vue&type=template&id=6221b939&scoped=true"
import script from "./hospitalCheckedReport.vue?vue&type=script&lang=js"
export * from "./hospitalCheckedReport.vue?vue&type=script&lang=js"
import style0 from "./hospitalCheckedReport.vue?vue&type=style&index=0&id=6221b939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221b939",
  null
  
)

export default component.exports